/*** IMPORTS FROM imports-loader ***/
var define = false;

import tagTester from './_tagTester.js';

export default tagTester('Object');




//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/_hasObjectTag.js
// module id = 128
// module chunks = 0